module.exports = __webpack_public_path__ + "static/media/printer.6efd96bf.svg";